import { toast } from "sonner";

import { API } from "./api";

async function fetchTicketAttachment(basePath, ticketId, att) {
  const r = await fetch(`${API}${basePath}/${ticketId}/attachments/${att.id}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("norea_token")}` },
  });
  if (!r.ok) throw new Error("download failed");
  return URL.createObjectURL(await r.blob());
}

export async function openTicketAttachment(basePath, ticketId, att) {
  const win = window.open("", "_blank");
  try {
    const url = await fetchTicketAttachment(basePath, ticketId, att);
    if (!win) { window.location.assign(url); return; }
    const name = (att.filename || "fichier").replace(/[<>&"]/g, "");
    win.document.title = name;
    win.document.body.style.margin = "0";
    win.document.body.innerHTML = `<iframe src="${url}" title="${name}" style="border:0;width:100vw;height:100vh;display:block"></iframe>`;
    setTimeout(() => URL.revokeObjectURL(url), 120000);
  } catch {
    if (win) win.close();
    toast.error("Impossible d'ouvrir la pièce jointe");
  }
}

export async function downloadTicketAttachment(basePath, ticketId, att) {
  try {
    const url = await fetchTicketAttachment(basePath, ticketId, att);
    const a = document.createElement("a");
    a.href = url;
    a.download = att.filename || "fichier";
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch {
    toast.error("Téléchargement impossible");
  }
}
